export const HOME_PATH = "/";
export const CREATE = "/create";
export const UPLOAD = "/upload";
